// Announcement title/content are plain-text fields with no rich-text editor,
// but text pasted from an AI assistant or another doc often carries markdown
// **bold** markers. We don't render markdown, so those show up as literal
// asterisks. This renders just that one construct — not a full markdown
// parser, on purpose, since these fields never had markdown support to begin
// with and a full parser would be a much bigger surface than the actual ask.
export function renderBoldText(text) {
  if (!text) return text;
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (part.length > 4 && part.startsWith('**') && part.endsWith('**')) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    return part;
  });
}
